import { gozokiApiWithAuth } from '../gozokiApi'

import type { ReapproAlgorithmParam } from '@gozoki/api-types'

export const fetchReapproAlgorithmParams = async () => {
  const response = await gozokiApiWithAuth.get<ReapproAlgorithmParam[]>(
    '/reappro-algorithms/params',
  )
  return response.data
}
